var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow2Right = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "8 10.001 14 9.333"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.585 15.25h11.466l-3.136 3.124a.56.56 0 0 0 0 .795c.221.22.578.22.799 0l4.121-4.104a.56.56 0 0 0 0-.795l-4.121-4.104a.566.566 0 0 0-.799 0 .56.56 0 0 0 0 .795l3.136 3.123H8.585a.59.59 0 0 0-.585.584.59.59 0 0 0 .585.583"
})));
export default SvgArrow2Right;